<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     费用中心-总览
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="expense-overview">
    <el-card shadow="never" class="mt-md">
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="front-line mb">账户余额</div>
          <div class="credit bg-light radius5 flex-center" style="height: 165px">
            <div :class="{ 'text-danger': arrear, 'text-success': !arrear }">
              <span class="font-lg">¥</span>
              <span class="ml-xs font-4x">{{ stats.balance || '--' }}</span>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="front-line mb">财务提醒</div>
          <div class="block-item bg-light radius5 card-item" role="button" @click="$router.push('/expense/flow?direct=2' + '&period=' + this_month)">
            <span class="title">本月消费</span>
            <span class="font-lg text-muted" :class="{ 'text-primary': stats.sum_month_expense > 0 }">{{ stats.sum_month_expense || 0 | currency }}</span>
          </div>
          <div class="mt block-item bg-light radius5 card-item" role="button" @click="$router.push('/expense/flow?direct=1' + '&period=' + this_month)">
            <span class="title">本月收入</span>
            <span class="font-lg text-muted" :class="{ 'text-primary': stats.sum_month_earn > 0 }">{{ stats.sum_month_earn || 0 | currency }}</span>
          </div>
          <div class="mt block-item bg-light radius5 card-item">
            <span class="title">可开发票</span>
            <span class="font-lg text-muted" :class="{ 'text-primary': stats.sum_uninvoiced > 0 }">{{ stats.sum_uninvoiced || 0 | currency }}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="front-line mb">待办提醒</div>
          <div
            class="block-item bg-light radius5 card-item"
            role="button"
            @click="$router.push('/expense/order')">
            <span class="title">待支付订单</span>
            <span
              class="font-lg text-muted"
              :class="{ 'text-danger': stats.count_order_topay > 0 }">{{ stats.count_order_topay }}</span>
            <span class="span text-muted">个</span>
          </div>
          <div
            class="mt block-item bg-light radius5 card-item"
            role="button"
            @click="$router.push('/expense/order')">
            <span class="title">待签收订单</span>
            <span
              class="font-lg text-muted"
              :class="{ 'text-danger': stats.count_order_tosign > 0 }">{{ stats.count_order_tosign }}</span>
            <span class="span text-muted">个</span>
          </div>
          <div
            class="mt block-item bg-light radius5 card-item"
            role="button"
            @click="$router.push('/expense/bill')">
            <span class="title">待确认账单</span>
            <span
              class="font-lg text-muted"
              :class="{ 'text-danger': stats.count_bill_topay > 0 }">{{ stats.count_bill_topay }}</span>
            <span class="span text-muted">份</span>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <el-card shadow="never" class="mt-md">
      <expense-trend-chart />
    </el-card>
  </div>
</template>

<script>

import { getExpenseOverviewApi } from '@/api/expense/expenseOverviewApi'
import ExpenseTrendChart from './components/ExpenseTrendChart'
export default {
  name: 'ExpenseOverview',
  components: {
    ExpenseTrendChart
  },
  data() {
    return {
      this_month: '',
      loading: false,
      stats: {
        balance: 0
      }
    }
  },
  computed: {
    arrear() {
      // eslint-disable-next-line
      return parseFloat(this.stats.balance) < 0 ? true : false 
    }
  },
  watch: {
  },
  created() {
    this.getMonth()
    this.fetchData()
  },
  methods: {
    getMonth() {
      const date = new Date(new Date())
      const y = date.getFullYear()
      let m = date.getMonth() + 1
      if (m < 10) {
        m = '0' + m
      }
      this.this_month = y + '-' + m
    },
    fetchData() {
      this.loading = true
      getExpenseOverviewApi().then(res => {
        this.loading = false
        if (!res.errno) {
          this.stats = Object.assign({}, res.data.stats)
        } else {
          this.$message.error(res.message)
        }
      })
    }
  }
}
</script>

<style lang="scss" slot-scoped>
.expense-overview {
  .credit {
    height: 162px;
  }
  .block-item {
    padding: 10px 20px;
    .title {
      display: inline-block;
      width: 160px;
      color: #666;
    }
    &.card-item {
    height: 45px;
    display: flex;
    align-items: center;
  }
  }
}
</style>
